var $ = jQuery.noConflict();
(function($, window, document, undefined) {
	var APP = {
		getMaxHeight: function(el) {
			var heights = $(el).map(function () {
				return $(this).outerHeight();
			}).get(),
			maxHeight = Math.max.apply(null, heights);
			return maxHeight;
		},

		wrapEveryNth: function(element, count, className) {
			var element = $(element),
				length 	= element.length;
			for(var i = 0; i < length ; i+=count) {
				element.slice(i, i+count).wrapAll('<div '+((typeof className == 'string')?'class="'+className+'"':'')+'/>');
			}
			return element;
		},

		equalHeightElements: function(array, container, reset) {
      if( !$(container).length ) {
        return;
			}
			
			reset = reset || 0;

      $.each(array, function(i, el) {
        var element = $(container).find(el);

        element.css('min-height', '1px');
        var maxHeight = APP.getMaxHeight(element);

        if( $(window).width() > reset ) {
          element.css('min-height', maxHeight);
        }else {
          element.css('min-height', '1px');
        }
      });
		},
		
		adj: function(row, title, excerpt) {
			/* var projects_row = $('.projects-row');
			
			projects_row.each(function() {
				var that = $(this),
					title = that.find('.project-inner h4'),
					excerpt = that.find('.project-excerpt');
				
				title.css({'min-height': '1px'});
				excerpt.css({'min-height': '1px'});				
				
				var titleH = APP.getMaxHeight(title),
					excerptH = APP.getMaxHeight(excerpt);
				
				title.css({'min-height': titleH});
				excerpt.css({'min-height': excerptH});		
			});	 */
			var row = $(row);
			$.each(row, function(i, el) {
				
				var that = $(this),
					$title = that.find(title),
					$excerpt = that.find(excerpt);
					
				$title.css({'min-height': '1px'});
				$excerpt.css({'min-height': '1px'});				
				
				var titleH = APP.getMaxHeight($title),
					excerptH = APP.getMaxHeight($excerpt);
				
				$title.css({'min-height': titleH});
				$excerpt.css({'min-height': excerptH});		
			});	
		},

		homeSlider: function() {
			var slider = $('.flexslider'),
				speed  = slider.attr('data-slide-speed'),
				effect = slider.attr('data-slide-effect');
			slider.flexslider({
				animation: 'slide',
				slideshowSpeed:speed,
				direction: 'horizontal',
				animationSpeed:1000,
				reverse:false,
				pauseOnHover:true,
				controlsContainer: $(".custom-controls-container"),
				customDirectionNav: $(".custom-navigation a"),
				controlNav:true,
				directionNav:true,
				start: function() {
					// adjust();
					// $(window).trigger('resize');
					arrows_adjust();
				},
				before: function(slider) {
					$('.flex-caption').fadeOut(300);
				},
				after: function(slider) {
					$('.flex-caption').fadeIn(500);
					arrows_adjust();
				}
			});
			
			$(window).on('resize', function() {
				// adjust();
				arrows_adjust();
			});
			
			function arrows_adjust() {
				if($('#s768').css('opacity') == 1) {
					var ci = $('.flex-caption-inner').outerHeight();
					var fl = $('.flex-arr').outerHeight();
					$('.flex-arr').css({'bottom':(ci-fl)/2});
				}else {
					$('.flex-arr').css({'bottom':''});
				}
			}
			
			function adjust() {
				var image 		= $('.flexslider img'),
					win			= $(window),
					container	= $('.container'),
					caption		= $('.flexslider').find('.flex-caption'),
					caption_inner = $('.flexslider').find('.flex-caption-inner');
					qc_left		= $('.quick-contact').offset().left;
					
				var hei = 500;
				var wid = 1920;
				if($('#s1152').css('opacity') == 1) {
					hei = 415;
					wid = 1714;
				}
				if($('#s992').css('opacity') == 1) {
					hei = 395;
					wid = 1631;
				}
				if($('#s768').css('opacity') == 1) {
					hei = 300;
					wid = 1239;
				}
				if($('#s480').css('opacity') == 1) {
					hei = 250;
					wid = 1032;
				}
				
				$('.flexslider, .flexslider img').css({
					'height':hei,
					'width':wid,
					'left':0,
					'right':0
				});	
				var image_width = image.width(),
					win_width	= win.width(),
					offset		= (image_width- win_width)/2;
					
				image.css({
					'position':'relative',
					'left': -offset	
				});	
				
				var percent = 0.11;
				if($('#s860').css('opacity') == 1) {
					percent = 0.07;
				}
				
				if($('#s768').css('opacity') == 1) {
					caption_inner.css({
						'left': 0	
					});
					caption.css({
						'right': 'auto'
					});
					caption_inner.css({'max-width':win_width});
				}else if($('#s1152').css('opacity') == 1) {
					caption_inner.css({
						'left': win_width*percent
					});
					caption.css({
						'right': 'auto'
					});
					
					var a = win_width - container.width();
					var b = qc_left - win_width*percent - 110;
			 
					caption_inner.css({'max-width':b});
					$('.flex-arr').css({'bottom':''});
				}else {
					caption_inner.css({
						'left': -(offset-30)	
					});
					caption.css({
						'right': 0
					});
					caption_inner.css({'max-width':''});
					$('.flex-arr').css({'bottom':''});
				}
						
			}
		},

		quick_contact: function() {

			var quickContact = $('.quick-contact'),
				scrollMenu = $('#scroll-menu');

			if( !quickContact.length ) return;

			$.each(quickContact, function(index, element) {
				
				var qc 						= $(element),
					qcForm 					= qc.find('.quick-contact-form'),
					qcHeader 				= qc.find('.qc-header'),
					qcFormBg 				= qcForm.find('.quick-contact-bg'),
					qcFormHeaderBg 	= qcFormBg.find('span'),
					qcFormContainer	= qc.find('.qcf-container'),
					qcFa						= qc.find('.qc-arrow i'),
					qcFormHeight 		= 450,
					fileInput 			= qcForm.find('.wpcf7-file');

				function quickContactLoad() {
					headerBgHeight 	= $('#s768').css('opacity') == 1 ? 37 : $('#quick-links').height();

					qcFormHeaderBg.css({
						'height' : headerBgHeight
					});

					qcHeader.css({
						'height' : headerBgHeight
					});

					qcFormBg.css({
						'top' : -headerBgHeight
					});

					if($('#s1152').css('opacity') == 1) {
						qcFormHeight = 400;
					}

					if($('#s992').css('opacity') == 1) {
						qcFormHeight = 390;
					}

					qcFormHeight = $('.flexslider').length && !qc.closest('#scroll-menu').length ? $('.flexslider').height() : qcFormHeight;
					
					if($('#s768').css('opacity') == 1) {
						qcFormHeight = 'auto';
					}
				}

				function quickContactHover() {
					if($('#s768').css('opacity') == 1) {
						qcHeader.off('mouseover');
						qc.off('mouseleave');
					}else {
						qcHeader.on('mouseover', function() {
							if( !qc.hasClass('open') ) {
								qc.addClass('open');
								qcFa.removeClass('fa-angle-down').addClass('fa-minus');	
								qcForm.css({
									'height' : qcFormHeight
								});
								qcFormContainer.stop().fadeIn(500);	
							}
						});

						qc.on('mouseleave', function() {
							var that = $(this);

							var input = that.find('input, textarea');

							if( that.hasClass('open') && !input.is(':focus') && !fileInput.hasClass('active') ) {
								that.find('.qc-header').trigger('click');
							}
						});
					}
				}

				qcHeader.on('click', function() {
					qc.toggleClass('open');
					fileInput.removeClass('active');

					if( qc.hasClass('open') ) {
						qcFa.removeClass('fa-angle-down').addClass('fa-minus');	
						qcForm.css({
							'height' : qcFormHeight
						});
						qcFormContainer.stop().fadeIn(500);	
					}else {
						qcFa.removeClass('fa-minus').addClass('fa-angle-down');
						qcFormContainer.css({
							'display':'none'
						});
						qcForm.css({
							'height' : ''
						});
					}
				});

				quickContactLoad();
				quickContactHover();

				$(window).on('resize', function() {
					quickContactLoad();
					quickContactHover();
				});

				$(window).on('scroll', function() {
					if( !scrollMenu.hasClass('menu-scrolled') && scrollMenu.find('.quick-contact.open') ) {
						scrollMenu.find('.quick-contact.open .qc-header').trigger('click');
					}

					if( scrollMenu.hasClass('menu-scrolled') && $('.quick-contact-static.open') ) {
						$('.quick-contact-static.open').find('.qc-header').trigger('click');
					}
				});

				setTimeout( function() {
					$(window).trigger('resize');
				}, 10);

			});
		},

		menu_active_slide: function() {
			if($('.current_page_parent').parent().hasClass('dropdown-menu')) {
				$('.current_page_parent').parent().parent().addClass('current_page_item active');	
			}
			
			var menu_container	= $('.menu-container');
			
			$(menu_container).each(function(index, element) {
					
				var menu_container	= $(this),
					marker 			= menu_container.find('.menu-active'),
					menu 			= menu_container.find('.navbar-nav'),
					active			= menu.find('li.active'),
					menu_link		= menu_container.find('.navbar-nav > li');
				
				function offset_left(el) {
					return el.prev().length > 0 ? 1 : 0
				}
				
				function offset_width(el) {
					return el.prev().length > 0 ? 2 : 0
				}
				
				if(active.length) {
					var active_pos 		= active.position().left - offset_left(active),
						active_width 	= active.outerWidth() + offset_width(active);
				}else {
					active_pos 		= -1000,
					active_width 	= 0;
				}
				
				marker.css({
					'left': active_pos,
					'width': active_width,
				});	
				
				menu_link.hover(
					function() {
						var hovered 		= $(this),
							hovered_offset 	= hovered.position().left - offset_left(hovered),
							hovered_width 	= hovered.width() + offset_width(hovered);
							
						marker.stop().animate({
							'left': hovered_offset-1,
							'width': hovered_width + 1,
						},100);
					}, 
					function() {
					}
				);
				menu_container.hover(
					function() {
					}, 
					function() {
						marker.stop().animate({
							'left': active_pos-1,
							'width': active_width + 1,
						},100);
					}
				);
            });
			
			$('#scroll-menu .navbar-mobile').removeClass('navbar-mobile').addClass('navbar-mobile2');
			$('#scroll-menu .navbar-toggle').attr('data-target', '.navbar-mobile2');
		},

		rfs_carousel: function(car, rwd, margin, controls_class, item_class, arrows, interval, rtl, center) {
			$(car).on('initialized.owl.carousel', function(e){
				var count = e.item.count;
				var controls = $(car).find('.owl-nav');
				count < 2 ? controls.hide() : controls.show();
			});
			
			var nav = controls_class == '' ? false : true;
			
			$(car).owlCarousel({
				loop: $(car).find(item_class).size() > 1 ? true : false,
				margin:margin,
				nav:nav,
				autoplay:true,
				center:center || false,
				autoplayTimeout:interval,
				autoplaySpeed:800,
				navSpeed:800,
				dotsSpeed:800,
				touchDrag:true,
				autoplayHoverPause:true,
				pullDrag:false,
				mouseDrag:false,
				callbacks: true,
				rtl:rtl,
				controlsClass:controls_class+'-controls',
				navText: [
				   "<i class='fa fa-"+arrows+"-left'></i>",
				   "<i class='fa fa-"+arrows+"-right'></i>"
				],
				responsive:rwd
			}); 	
		}, 

		latest_projects_carousel: function() {
			rwd = {
				0:{items:1},
				992:{items:2}
			};
			APP.rfs_carousel('#latest-projects-carousel', rwd, 0, 'latest-projects', '.latest-project', 'angle', 3000, false); 	
		}, 

		latest_news_carousel: function() {
			rwd = {
				0:{items:1}
			};
			APP.rfs_carousel('#latest-news-carousel', rwd, 0, 'latest-news', '.latest-news-item', 'angle', 3000, false); 	
		}, 

		partners_carousel: function() {
			rwd = {
				0:{items:1},
				480:{items:2},
				640:{items:3},
				768:{items:4},
				992:{items:5},
			};
			APP.rfs_carousel('#partners-carousel', rwd, 5, '', '.partner', 'angle',1000, false); 	
		}, 

		accreditations_carousel: function() {
			rwd = {
				0:{items:1},
				480:{items:2},
				640:{items:3},
				768:{items:4},
				992:{items:5},
			};
			APP.rfs_carousel('#accreditations-carousel', rwd, 5, '', '.accreditation', 'angle',1000, true); 	
		}, 
		
		gallery_carousel: function() {
			var defaults = {
				margin: 0,
				nav: true,
				dots: true,
				autoplay: true,
				autoplayTimeout: 5000,
				autoplaySpeed: 1000,
				navSpeed: 1000,
				dotsSpeed: 1000,
				touchDrag: true,
				autoplayHoverPause: true,
				pullDrag: true,
				mouseDrag: true,
				callbacks: true,
			}

			var carouselMain = $('.gallery-main-carousel'),
				optionsMain = {
					loop: true,
					nav: false,
					autoplay: false,
					responsive: {},
					items: 1
				},
				argsMain = $.extend(defaults, optionsMain);
	
			carouselMain.owlCarousel(argsMain);
			
			var carouselNav = $('.gallery-nav-carousel'),
				optionsNav = {
					loop: carouselNav.find('.gallery-nav-item').size() > 1 ? true : false,
					controlsClass:'gn-controls',
					nav: true,
					center: true,
					autoplaySpeed: 300,
					navSpeed: 300,
					dotsSpeed: 300,
					navText: [
					"<i class='fa fa-angle-left inline-block'></i>",
					"<i class='fa fa-angle-right inline-block'></i>"
					],
					responsive:{
						0: {
							items: 3,
							margin: 5
						},
						480: {
							items: 3,
							margin: 5
						},
						900: {
							items: 3,
							margin: 15
						}
					}
				},
				argsNav = $.extend(defaults, optionsNav);

			carouselNav.on('translate.owl.carousel', function(event) {
				var that = $(this),
					centered = that.find('.owl-item.active.center'),
					centeredIndex = event.page.index;

				if( centered.length > 0 ) {
					carouselMain.trigger('to.owl.carousel', centeredIndex, 500);
				}
			});
	
			carouselNav.on('initialized.owl.carousel changed.owl.carousel', function(event) {
				var that = $(this),
					item = that.find('.gallery-nav-item');
	
				item.first().addClass('current');
	
				item.on('click', function() {
					var thumbnail = $(this),
						index = thumbnail.attr('data-gallery-nav-item');
	
					item.removeClass('current');
					thumbnail.addClass('current');
					carouselMain.trigger('to.owl.carousel', index, 500);
					carouselNav.trigger('to.owl.carousel', index, 500);
				});
			});
				
			carouselNav.owlCarousel(argsNav);
		},

		hp_slides_carousel: function() {
			var defaults = {
				margin: 0,
				nav: true,
				dots: false,
				autoplay: true,
				autoplayTimeout: 5000,
				autoplaySpeed: 800,
				navSpeed: 800,
				dotsSpeed: 800,
				touchDrag: true,
				autoplayHoverPause: false,
				pullDrag: true,
				mouseDrag: false,
				callbacks: true,
				animateOut: 'fadeOut',
				controlsClass:'hp-controls',
				navText: [
				"<i class='fa fa-angle-left inline-block'></i>",
				"<i class='fa fa-angle-right inline-block'></i>"
				],
			}

			var carousel = $('.hp-slides-carousel'),
				options = {
					///loop: true,
					responsive: {},
					items: 1
				},
				args = $.extend(defaults, options);
	
			carousel.owlCarousel(args);
		},

		airgroups_carousel: function() {
			rwd = {
				0: {
					items: 1
				},
				640: {
					items: 2,
					center: false
				},
				992: {
					items: 3,
					center: true
				}
			};

			$('.airgroups-carousel').on('initialized.owl.carousel translated.owl.carousel', function(event){
				var carousel = event.target;
					firstActive = $(carousel).find('.owl-item.active').first();

					firstActive.addClass('is-active');

				var items = [
					'.airgroup-image',
					'.airgroup-header',
					'.airgroup-text',
				];

				APP.equalHeightElements(items, '.airgroups-carousel');
			});

			$('.airgroups-carousel').on('translate.owl.carousel', function(event){
				var carousel = event.target;

					$(carousel).find('.owl-item').removeClass('is-active');
			});

			APP.rfs_carousel('.airgroups-carousel', rwd, 0, 'airgroups', '.airgroup', 'angle', 3000, false);

		},

		wwd_carousel: function() {
			rwd = {
				0: {
					items: 1
				},
				640: {
					items: 2
				},
				768: {
					items: 3,
					margin: 20
				},
				992: {
					items: 4,
					margin: 20
				},
				1152: {
					items: 5,
					nav: false,
					autoplay: false,
					margin: 20,
				}
			};

			APP.rfs_carousel('.wwd-carousel', rwd, 0, 'wwd', '.wwd-box', 'angle', 3000, false);

		},

		team_carousel: function() {
			rwd = {
				0:{
					items:1
				},
				540:{
					items:2
				},
				860:{
					items:3
				}
			};
			APP.rfs_carousel('#team-carousel', rwd, 50, 'team', '.team-item', 'angle' ,3000, false); 	
		},

		related_services_carousel: function() {
			rwd = {
				0: {
					items: 1,
					loop: true
				},
				768: {
					items: 2,
					loop: true,
					margin: 10,
				},
				1152: {
					items: 2,
					loop: true,
					autoplay: false,
					margin: 20,
				}
			};

			$('.related-services-carousel').on('initialized.owl.carousel translated.owl.carousel', function(event){
				APP.adj('.related-services', '.project-inner h4', '.project-excerpt');
			});

			APP.rfs_carousel('.related-services-carousel', rwd, 0, 'wwd', '.wwd-box', 'angle', 3000, false);

		},

		related_projects_carousel: function() {
			rwd = {
				0: {
					items: 1,
					loop: true
				},
				768: {
					items: 3,
					loop: true,
					margin: 10,
				},
				992: {
					items: 4,
					autoplay: false,
					loop: true,
					margin: 20,
				}
			};

			$('.related-projects-carousel').on('initialized.owl.carousel translated.owl.carousel', function(event){
				APP.adj('.single-bottom .row', '.project-inner h4', '.project-excerpt');
			});

			APP.rfs_carousel('.related-projects-carousel', rwd, 0, 'wwd', '.wwd-box', 'angle', 3000, false);

		},
		
		form_file_upload: function() {
			var wpcf7form = $('.wpcf7-form');

			if( !wpcf7form.length ) {
				return;
			}

			$.each(wpcf7form, function(index, element) {
				var form 		= $(element),
					fileBlock = form.find('.form-file'),
					submitBtn = form.find('.wpcf7-submit'),
					fileInput = form.find('input[type=file]')

					submitBtn.on('click', function() {
						if( $.trim( fileInput.val() ) == '' ) {
							fileInput.attr('disabled', true);
						}
					});

					form.on('submit', function() {
						fileInput.attr('disabled', false);
					})
					
					fileBlock.hide();
					fileBlock.first().show();

					$.each(fileBlock, function(i, el) {
						var fileBox = $(el),
							label 		= fileBox.find('label'),
							file   		= fileBox.find('.wpcf7-file');

						label.on('click', function() {
							file.trigger('click').addClass('active');
						});

						file.on('change', function() {
							var that = $(this);
		
							if( that[0].files.length ) {
								var filename = that[0].files[0].name;
			
								label.text(filename);	
								fileBox.nextAll('.form-file:first').show();
							}
						});

					});
			});

			$('.wpcf7').on('wpcf7:invalid', function(event){
				var fileError = $('.form-file').find('.wpcf7-not-valid-tip');

				$.each(fileError, function(index, element) {
					var error = $(element),
						label 	= error.closest('.form-file').find('label'),
						file 		= error.closest('.form-file').find('.wpcf7-file');

						if( file.val() != '' && label.find('small').length == 0 ) {
							label.append(' <small class="color-red">(invalid file type)</small>');
						}
				});
			});

		},
		
		menu_links: function() {
			$('.navbar .dropdown > a').on('click', function(){
				if($('#s768').css('opacity') == 0) {
					location.href = this.href;
				}else {
					location.href = '#';
				}
			});	

			$('.navbar .dropdown1').hover(function() {
				var that 	= $(this),
					submenu = that.find('.dropdown-menu').first(),
					li 			= submenu.find('li.dropdown2');

					setTimeout(function() {
						li.css('min-height', '1px');
						var maxH = APP.getMaxHeight(li);
						li.css('min-height', maxH);
					}, 10);

			}, function() {
			});
			
			$('.navbar .dropdown1').each(function() {
				var that = $(this),
					menu = that.find('.dropdown-menu').first(),
					list_items = menu.find('li');
					
				if(list_items.length==1) {
					list_items.addClass('pull-right');
				}
			})
			if(!$('.dropdown1 img').parent().hasClass('menu-image')) {
				$('.dropdown1 img').wrap('<span class="menu-image"></span>');
			}
			
			$('.dropdown1').hover(
				function() {
					$(this)
						.find('.dropdown-menu').first()
						.css({
							'opacity': 0,
							'top': '130%'
						})
						.show()
						.stop().animate({
							'top' : '100%',
							opacity: 1	
						},200);
				}, 
				function() {
					$(this)
						.find('.dropdown-menu').first()
						.stop().animate({
							top: '130%',
							opacity: 0
						},200, function() {
							$(this).hide();	
						})
				}
			);
		},

		menu_on_scroll: function() {
			scrollMenu = $('#scroll-menu');

			function menu_toogle() {
				var scrolltop = $(window).scrollTop();
				var quickContact = $('.quick-contact');

				if( quickContact.hasClass('open') ) {
					return;
				}

				if( scrolltop > 150 ) {
					$(scrollMenu).addClass('menu-scrolled').css({'opacity':''}).stop().animate({ top:0 }, 200);	
				}else {
					$(scrollMenu).removeClass('menu-scrolled').css({'opacity':'-1'}).stop().animate({ top:-300 }, 200);	
				}
			}
			
			menu_toogle();
			
			$(window).on('scroll', function() {
				menu_toogle();
			});
		},
	
		height_adjustments: function() {
			APP.adj('.projects-row', '.project-inner h4', '.project-excerpt');
			APP.adj('.industries-row', '.industry-inner h4', '');
			APP.adj('.home-industries-row', '.home-industry-inner h4', '');
			APP.adj('.single-bottom .row', '.project-inner h4', '.project-excerpt');
		},
		
		service_standards: function() {
			var st = $('.service-standards');
			
			$.each(st, function() {
				var that 	= $(this),
					expand 	= that.find('.ss-expand'),
					content = that.find('.ss-content');

				if( that.hasClass('in') ) {
					content.show();
				}

				expand.on('click', function() {
					content.slideToggle();
					that.toggleClass('in');
				});
			});
		},

		filterBarSubmitOnChage: function() {
			var bar = $('.search-bar');

			if( !bar.length ) {
				return;
			}

			var select = bar.find('.selectpicker');

			select.on('changed.bs.select', function (e) {
				bar.find('form').submit();
			});
		}
	}
	
	$(document).on( "wplc_open_chat_1", function( e ) {
		//$('#wp-live-chat-2-inner #wplc_start_chat_btn').addClass('skew transition-fast').wrapInner('<span class="unskew-text"></span>');
	});
	
	$(document).ready(function(e) {
		APP.homeSlider();
		APP.latest_projects_carousel();
		APP.latest_news_carousel();
		APP.partners_carousel();
		APP.accreditations_carousel();
		APP.form_file_upload();
		APP.menu_links();
		APP.team_carousel();
		
		APP.quick_contact();
		APP.height_adjustments();
		APP.service_standards();
		APP.filterBarSubmitOnChage();
	});
	$(window).on('load', function() {
		APP.menu_on_scroll();
		APP.gallery_carousel();
		APP.hp_slides_carousel();
		APP.airgroups_carousel();
		APP.wwd_carousel();
		APP.related_services_carousel();
		APP.related_projects_carousel();
	});
	$(window).on('load resize', function() {
		APP.menu_active_slide();
	});
	
})(jQuery, window, document);